export const IndividualResultState = {
  errorMessage: '',
  isLoading: false,
  result: {},
  wasStopped: true,
  args: {}
};
